import * as styles from './errorBanner.module.css';

type ErrorBannerProps = {
  message: string;
};

const ErrorBanner = ({ message }: ErrorBannerProps) => (
  <div className={styles.formErrorBanner}>{message}</div>
);

export default ErrorBanner;
